/**
 * The original's error helpers — module `72767`, exports `Y2` (the message map)
 * and `iC` (the extractor). Ported verbatim, including the fallback string.
 *
 * The extractor is what every one of the original's `catch` blocks runs before
 * it raises a snackbar: the SERVER's own message wins, then an explicit
 * fallback, then the generic. Nothing about it is invented, which is why our
 * failure paths use it rather than a string of our own.
 */

/** `Y2` — the three order-conflict messages the API answers with by code. */
export const ERROR_MESSAGES = {
  ORDER_VERSION_MISMATCH: "This version of the order is outdated",
  ORDER_IDEMPOTENCY: "Order Already Created",
  ORDER_NO_CHANGES: "No changes in the order",
} as const;

/**
 * `iC` — `getErrorMessage(error, fallback)`. Verbatim: a string passes through,
 * an axios `response.data` string wins next, then the caller's fallback, then
 * the generic. An `Error` object deliberately does NOT contribute its
 * `message` — pass it as the fallback if you want it.
 */
export const getErrorMessage = (error: unknown, fallback?: string): string => {
  if (typeof error === "string") return error;
  const response = (error as { response?: { data?: unknown } } | null)?.response;
  if (typeof response?.data === "string") return response.data;
  return fallback ?? "An Error Occurred";
};
